import { motion } from 'framer-motion'
import { useIntl } from 'react-intl'

import { Spinner } from '../ui'

export const Loader = () => {
  const intl = useIntl()

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.1 }}
      className="fixed inset-0 flex h-screen w-screen items-center justify-center"
      aria-label={intl.formatMessage({
        defaultMessage: 'Loading',
        id: 'label.loading',
      })}
    >
      <Spinner className="size-16" />
    </motion.div>
  )
}
